<template>
  <main class="lp">
    <!-- HERO SECTION -->
    <section class="hero">
      <div class="container-initial">
        <h1 class="hero-title">
          Policial Orientado e Protegido:
        </h1>
        <h2 class="hero-subtitle">
          o guia prático para identificar e recuperar o dinheiro que o Estado está te devendo
        </h2>
        
        <p class="hero-text">
          Descubra, de forma simples e direta, quais valores você pode ter direito a receber — e como agir de forma segura e embasada para reaver o que é seu por lei.<br>
          Palestra 100% gratuita e online, exclusiva para policiais civis de Minas Gerais.
        </p>
      </div>
    </section>

    <!-- BOTÃO FLUTUANTE ENTRE SEÇÕES -->
    <div class="floating-cta">
      <a href="javascript:void(0)" class="btn-primary" @click.prevent="invokeDialog()">
        QUERO PARTICIPAR<br>GRATUITAMENTE
      </a>
    </div>

    <!-- SEGUNDA SEÇÃO: PROBLEMA E SOLUÇÃO -->
    <section class="section-problem">
      <div class="container">
        <p class="problem-text">
          Todo policial civil dedica anos de vida ao serviço público, mas poucos sabem que o Estado pode estar deixando de pagar valores significativos — e que, muitas vezes, o prazo para cobrar esses direitos está acabando.
        </p>

        <p class="problem-text">
          Seja por falta de informação, burocracia ou interpretações erradas da lei, benefícios e gratificações acabam esquecidos, prejudicando o bolso e o reconhecimento de quem serviu com dedicação.
        </p>

        <h3 class="problem-title">Se você sente que:</h3>

        <ul class="problem-checklist">
          <li>Nunca recebeu tudo que tinha direito</li>
          <li>Que seu esforço não tem sido valorizado</li>
          <li>Quer entender de forma prática onde pode haver valores a recuperar</li>
        </ul>

        <div class="cta-center">
          <a href="javascript:void(0)" class="btn-secondary" @click.prevent="invokeDialog()">
            Então essa palestra é para você!
          </a>
        </div>
      </div>
    </section>

    <!-- TERCEIRA SEÇÃO: TÓPICOS EM FOCO -->
    <section class="section-topics">
      <div class="container">
        <h2 class="topics-title">Durante a palestra, você vai entender:</h2>

        <ul class="topics-checks">
          <li>Como identificar valores que o Estado pode estar te devendo, de forma simples e segura.</li>
          <li>Quais direitos estão sendo mais frequentemente violados — e como agir juridicamente para recuperá-los.</li>
          <li>Todo o panorama sobre:</li>
        </ul>

        <ul class="topics-list">
          <li>Gratificação de Incentivo ao Exercício Continuado (GIEC);</li>
          <li>Promoções e Progressões;</li>
          <li>Férias regulamentares e prêmio;</li>
          <li>Verbas retroativas e diferenças não pagas;</li>
          <li>Direitos específicos dos policiais civis de Minas Gerais.</li>
        </ul>

        <p class="topics-final">
          E o melhor: tudo isso explicado em linguagem clara, objetiva e acessível — sem juridiquês!
        </p>
      </div>
    </section>

    <!-- QUARTA SEÇÃO: PALESTRANTE -->
    <section class="section-speaker">
      <div class="container">
        <div class="speaker-grid">
          <div class="speaker-text">
            <p>
              Sou Tatiana Andrade, advogada especialista em Direito Administrativo, com foco em servidores públicos e policiais civis de Minas Gerais.
            </p>
          </div>
          <figure class="speaker-photo">
            <img src="@/assets/tatiana_andrade.png" alt="Foto de Tatiana Andrade" />
          </figure>
        </div>
        <div class="speaker-text-full">
          <p class="emphasis">
            Mais do que uma advogada, sou também policial civil aposentada, e sei na pele o que é enfrentar a burocracia, a desvalorização e o silêncio do Estado diante de direitos legítimos.
          </p>
          <p>
            Minha missão hoje é ajudar outros colegas a se orientarem juridicamente, recuperarem o que lhes é devido e se protegerem de injustiças.
          </p>
          <p>
            Com uma linguagem direta e acessível, vou te mostrar como entender seus direitos e agir da maneira certa, sem depender de “achismos” ou informações desencontradas.
          </p>
        </div>
      </div>
    </section>

    <!-- ÚLTIMA SEÇÃO: BENEFÍCIOS E EVENTO -->
    <section class="section-event">
      <div class="event-bg">
        <div class="event-content">
          <h2 class="event-title">Ao participar, você vai:</h2>
          <ul class="event-list">
            <li>Entender de forma prática quais valores e direitos estão sendo ignorados.</li>
            <li>Saber como agir corretamente para garantir o que é seu.</li>
            <li>Receber orientações jurídicas exclusivas, pensadas para a realidade dos policiais civis de MG.</li>
            <li>Ficar por dentro de atualizações legais que podem impactar sua carreira e aposentadoria.</li>
          </ul>
          <p class="event-highlight">Tudo isso em uma palestra gratuita, objetiva e transformadora!</p>
          <div class="event-cta-center">
            <a href="javascript:void(0)" class="btn-event" @click.prevent="invokeDialog()">QUERO PARTICIPAR GRATUITAMENTE</a>
          </div>
          <div class="event-info">
            <p class="event-details">
              <strong>Data:</strong> 14 de novembro de 2025 (sexta-feira)<br>
              <strong>Horário:</strong> 19h<br>
              <strong>Local:</strong> Online, via Google Meet<br>
              <strong>Duração:</strong> aproximadamente 50 minutos
            </p>
          </div>
          <p class="event-desc">
            Garanta sua vaga agora e venha descobrir o que o Estado pode estar te devendo.<br><br>
            Vagas limitadas para garantir um encontro direto e esclarecedor.
          </p>
          <div class="event-cta-center">
            <a href="javascript:void(0)" class="btn-event2" @click.prevent="invokeDialog()">GARANTIR MINHA VAGA AGORA</a>
          </div>
        </div>
      </div>
    </section>
    <ConfirmacaoModal :visible="dialogVisible" @submitted="submitted" />
    <ConfirmadoModal :visible="dialogDoneVisible" @end="end" />
  </main>
</template>

<script>
import ConfirmacaoModal from '@/components/ConfirmacaoModal.vue';
import ConfirmadoModal from '@/components/ConfirmadoModal.vue';

export default {
  components: {
    ConfirmacaoModal,
    ConfirmadoModal
  },
  name: 'LandingPage',
  data() {
    return {
      dialogVisible: false,
      dialogDoneVisible: false,
    };
  },
  methods: {
    invokeDialog() {
      console.log('invokeDialog called');
      this.dialogVisible = true;
    },
    submitted(formData) {
      console.log('Form submitted with data:', formData);
      this.dialogVisible = false;
      this.dialogDoneVisible = true;
    },
    end() {
      this.dialogDoneVisible = false;
      setTimeout(() => {
        location.reload();
      }, 1000);
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');
.montserrat-100 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 100;
  font-style: normal;
}
.montserrat-200 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 200;
  font-style: normal;
}
.montserrat-300 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 300;
  font-style: normal;
}
.montserrat-400 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}
.montserrat-500 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}
.montserrat-600 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: normal;
}
.montserrat-700 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
}
.montserrat-800 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 800;
  font-style: normal;
}
.montserrat-900 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 900;
  font-style: normal;
}

/* Reset e base */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.lp {
  width: 100%;
  font-family: 'Montserrat', sans-serif;
  margin: 0 auto;
}

.container-initial {
  max-width: 300px;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
  z-index: 2;
  padding-top: 40px;
}

.container {
  max-width: 500px;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
  z-index: 2;
  padding-top: 20px;
}

/* HERO SECTION */
.hero {
  background-image: url('@/assets/topo_dourado.png');
  background-size: cover;
  background-position: center, right center;
  background-repeat: no-repeat;
  color: #FFFFFF;
  padding: 48px 0 60px;
  position: relative;
  overflow: hidden;
  min-height: 600px;
}

.hero-title {
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 16px;
  color: #D4A574;
  letter-spacing: 0.5px;
}

.hero-subtitle {
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.4;
  margin-bottom: 24px;
  color: #FFFFFF;
}

.hero-text {
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 32px;
  color: #F5F5F5;
  max-width: 540px;
}

.hero-cta {
  margin-top: 36px;
}

/* BOTÃO FLUTUANTE ENTRE SEÇÕES */
.floating-cta {
  position: relative;
  text-align: center;
  margin-top: -30px;
  z-index: 10;
  padding: 0 24px;
}

.btn-primary {
  display: inline-block;
  background: linear-gradient(135deg, #C9A067 0%, #B38B5D 100%);
  color: #521817;
  padding: 16px 40px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
  text-decoration: none;
  line-height: 1.4;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border: 2px solid transparent;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
  background: linear-gradient(135deg, #D4A574 0%, #C9A067 100%);
}

/* SEGUNDA SEÇÃO: PROBLEMA E SOLUÇÃO */
.section-problem {
  background: 
    url('@/assets/policia_civil_branca.png');
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  padding: 30px 0 60px;
  border-radius: 20px;
  margin: 2px auto;
}

.problem-text {
  font-size: 1rem;
  line-height: 1.7;
  color: #2D1810;
  margin-bottom: 20px;
  text-align: left;
}

.problem-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #5A2C2C;
  margin: 32px 0 20px;
}

.problem-checklist {
  list-style: none;
  padding: 0;
  margin: 24px 0 40px;
}

.problem-checklist li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 1rem;
  line-height: 1.6;
  color: #2D1810;
  margin-bottom: 16px;
  padding-left: 8px;
}

.problem-checklist li::before {
  content: "✓";
  color: #8B4545;
  font-weight: 700;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.cta-center {
  text-align: center;
  margin-top: 40px;
}

.btn-secondary {
  display: inline-block;
  background: #5A2C2C;
  color: #FFFFFF;
  padding: 16px 40px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
  text-decoration: none;
  line-height: 1.4;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
  background: #6B3333;
}

/* TERCEIRA SEÇÃO: TÓPICOS EM FOCO */
.section-topics {
  background: #521817; /* vinho escuro */
  color: #FFFFFF;
  padding: 14px 0 48px;
}

.topics-title {
  font-weight: 800;
  font-size: 1.15rem;
  line-height: 1.4;
  margin-bottom: 18px;
}

.topics-checks {
  list-style: none;
  padding: 0;
  margin: 8px 0 18px;
}

.topics-checks li {
  position: relative;
  padding-left: 32px;
  margin: 10px 0;
  line-height: 1.6;
}

.topics-checks li::before {
  content: "✅"; /* check verde como no mock */
  position: absolute;
  left: 0;
  top: 0;
  font-size: 1.1rem;
}

.topics-list {
  list-style: disc;
  margin: 12px 0 18px 22px;
  color: #F7F7F7;
}

.topics-list li {
  margin: 8px 0;
}

.topics-final {
  margin-top: 18px;
  font-weight: 800;
  color: #FFFFFF;
}

/* QUARTA SEÇÃO: PALESTRANTE */
.section-speaker {
  background: #FFFFFF;
  color: #521817;
  padding: 36px 0 44px;
}

.speaker-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;
  margin-bottom: 18px;
}

.speaker-text p {
  font-size: 1rem;
  line-height: 1.7;
  margin: 14px 0;
}

.speaker-text-full .emphasis {
  font-weight: 800;
}

.speaker-photo {
  margin: 0;
  border-radius: 12px;
  padding: 6px;
  width: 100%;
  max-width: 320px;
  margin-top: 20px;
}

.speaker-photo img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.speaker-text-full {
  margin-top: 8px;
}
.speaker-text-full p {
  font-size: 1rem;
  line-height: 1.7;
  margin: 14px 0;
}

@media (min-width: 860px) {
  .speaker-grid {
    grid-template-columns: 1fr 320px;
    gap: 32px;
    align-items: center;
  }
}

/* Responsivo */
@media (max-width: 768px) {
  .hero {
    min-height: 500px;
    padding: 36px 0 48px;
  }

  .hero-title {
    font-size: 1.5rem;
  }

  .hero-subtitle {
    font-size: 1.1rem;
  }

  .hero-text {
    font-size: 0.95rem;
  }

  .btn-primary {
    font-size: 0.95rem;
    padding: 14px 32px;
  }

  .section-problem {
    padding: 36px 0 48px;
  }

  .problem-text {
    font-size: 0.95rem;
  }

  .problem-title {
    font-size: 1rem;
    margin: 24px 0 16px;
  }

  .problem-checklist li {
    font-size: 0.95rem;
    margin-bottom: 12px;
  }

  .btn-secondary {
    font-size: 0.95rem;
    padding: 14px 32px;
  }

  .topics-title {
    font-size: 1.05rem;
  }
  .topics-checks li { font-size: 0.98rem; }
  .topics-list li { font-size: 0.98rem; }
}
.section-event {
  width: 100%;
  margin: 0;
  padding: 0;
}
.event-bg {
  position: relative;
  background: transparent;
  color: #521817;
  padding: 32px 0 0 0;
  overflow: hidden;
}
.event-bg::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('@/assets/pc.png');
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 1;
  z-index: 0;
}
.event-bg::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('@/assets/pc2.png');
  background-size: cover;
  opacity: 0.45; /* segunda opacidade */
  z-index: 1;
}
.event-content {
  position: relative;
  z-index: 2;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 24px 32px 24px;
}
.event-title {
  font-size: 1.08rem;
  font-weight: 700;
  margin-bottom: 18px;
}
.event-list {
  list-style: disc;
  color: #fff;
  margin: 0 0 18px 22px;
}
.event-list li {
  margin: 8px 0;
  font-size: 1rem;
}
.event-highlight {
  font-weight: 700;
  margin: 18px 0 22px;
  color: #fff;
}
.event-cta-center {
  text-align: center;
  margin: 18px 0 0 0;
}
.btn-event {
  display: inline-block;
  background: #521817;
  color: #B98B63;
  padding: 16px 40px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
  text-decoration: none;
  line-height: 1.4;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
  border: none;
}
.btn-event:hover {
  background: #B98B63;
  color: #521817;
}
.btn-event2 {
  display: inline-block;
  background: #521817;
  color: #ffffff;
  padding: 16px 40px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
  text-decoration: none;
  line-height: 1.4;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
  border: none;
}
.btn-event2:hover {
  background: #ffffff;
  color: #521817;
}
.event-info {
  position: relative;
  background: #521817;
  opacity: 0.7;
  color: #fff7ed;
  padding: 12px 5px;
  margin: 15px 0px;
  width: 100vw;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
}
.event-details {
  font-size: 1.08rem;
  font-weight: 700;
  margin-bottom: 18px;
}
.event-desc {
  font-size: 1rem;
  margin-bottom: 22px;
  color: #521817;
  font-weight: bold;
}
@media (max-width: 768px) {
  .event-content, .event-info {
    padding-left: 12px;
    padding-right: 12px;
  }
  .event-title {
    font-size: 1rem;
  }
  .event-list li, .event-desc, .event-details {
    font-size: 0.97rem;
  }
  .btn-event {
    font-size: 0.97rem;
    padding: 14px 32px;
  }
}
</style>